<template>
  <div>
    <FormMultiSelect :value="value" @input="valueUpdated" :field="field" :options="listData" :loading="listLoading" placeholder="Select Items" v-if="!errorLabel && editable" />
    <span v-if="!editable">
      <span class="label label-success mr-1" v-for="objectId in value" :key="objectId">
        {{getLookupName(listData, objectId)}}
      </span>
    </span>
    <span class="text-danger" v-if="errorLabel">{{errorLabel}}</span>
  </div>
</template>

<script>
import form from '@/mixins/form'

import { LinkTypes } from '@/store/types'

export default {
  name: "AutomationDynamicListInput",
  mixins: [form],
  props: {
    linkType: String,
    field: String,
    value: Array,
    editable: Boolean
  },
  data() {
    return {
      listData: [],
      listLoading: false,
      errorLabel: null
    }
  },
  mounted() {
    // Get list
    // Based on the LinkType specified. We only support a limited number of LinkTypes currently. Expand on as required
    // Assumes the list data has 'id' & 'name' fields
    this.listLoading = true
    this.errorLabel = null

    var serviceCall = null
    switch(this.linkType) {
      case LinkTypes.contact:
        serviceCall = this.$apiService.contactService.getContactList({ isActive: 1 })
        break
      case LinkTypes.taskType:
        serviceCall = this.$apiService.tasksService.getTaskTypeList({ filter: { isActive: 1 } })
        break

      default:
        this.errorLabel = `Unknown dynamic list type '${this.linkType}'`
    }

    if(serviceCall) {
      serviceCall.then(list => {
        this.listData = list.data.map(objectInfo => {
          return {
            value: objectInfo.id,
            name: objectInfo.name
          }
        })
        this.listLoading = false
      })
      .catch(err => {
        this.listLoading = false
        if(err.response.status == 403)
          this.errorLabel = 'Permission denied to access list'
        else
          this.errorLabel = 'Error accessing list'
      })
    }
  },
  computed: {
  },
  methods: {
    valueUpdated(evt) {
      this.$emit('input', evt)

      // Also update lookup info too
      var lookupData = {}
      if(evt) {
        evt.forEach(listValue => {
          lookupData[parseInt(listValue)] = this.getLookupName(this.listData, listValue)
        })
      }

      this.$emit('updateInfo', lookupData)
    }
  }
}
</script>